import { render, staticRenderFns } from "./MediaManager.vue?vue&type=template&id=5efbc0ee&scoped=true&"
import script from "./MediaManager.vue?vue&type=script&lang=js&"
export * from "./MediaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efbc0ee",
  null
  
)

export default component.exports